var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"v-view-primary"},[_c('h1',{staticClass:"a-loading-primary"},[_vm._v("Página no encontrada")])])
}]

export { render, staticRenderFns }